// extracted by mini-css-extract-plugin
export var container = "Intro-module--container--931f3";
export var layout = "Intro-module--layout--f033c";
export var logo = "Intro-module--logo--bd644";
export var title = "Intro-module--title--e41af";
export var titleRow = "Intro-module--titleRow--59443";
export var info = "Intro-module--info--6a3dc";
export var description = "Intro-module--description--7077c";
export var dates = "Intro-module--dates--94b53";
export var location = "Intro-module--location--692b1";
export var pin = "Intro-module--pin--cbf02";
export var address = "Intro-module--address--c9b44";
export var picture = "Intro-module--picture--83e33";